import React from 'react';

const ContentHeader = ({ contentName }) => <div className="contentHeader text-center"><h1>{contentName}</h1></div>;

export default ContentHeader;
